import React, {useMemo, useState} from 'react'
// antd
import {Divider, Space, Spin} from 'antd'
// component
import {EmptyPanel, ListItemBlockComponent} from '@/components/elements'
// utils
import {randomCoding} from '@/utils'
// antd-pro
import ProCard from '@ant-design/pro-card'
import EditAppModal from '@/pages/itg/add'

interface IProps {
  list: any
  loading: boolean
  reload: () => void
  corpId: string
}

/**
 * 详情的应用信息
 * @constructor
 */
const AppListCard = (props: IProps) => {

  const [AppEditEn, setAppEditEn] = useState<any>()
  const [ReadAppInfo, setReadAppInfo] = useState<boolean>(false)

  const listDom = useMemo(() => {
    if (props.list.length == 0) {
      return <EmptyPanel description={"暂无应用信息"}/>
    }
    return <>
      {
        props.list.map((item: any, index: number) => {
          return <ListItemBlockComponent
            key={index}
            title={item.appName}
            appType={item.appType}
            showIcon
            extra={[
              <Space key={randomCoding()} split={<Divider className={"bg-gray-300"} type={"vertical"}/>}>
                <a onClick={() => {
                  setReadAppInfo(false)
                  setAppEditEn(item)
                }}>编辑</a>
                <a onClick={() => {
                  setReadAppInfo(true)
                  setAppEditEn(item)
                }}>详情</a>
              </Space>
            ]}
          />
        })
      }
    </>
  }, [props.list])

  return (
    <ProCard title={"应用信息"} bordered>
      {
        AppEditEn && <EditAppModal
              en={AppEditEn}
              readonly={ReadAppInfo}
              corpId={props.corpId}
              close={(reload) => {
                setAppEditEn(undefined)
                reload && props.reload()
              }}
          />
      }
      <Spin spinning={props.loading}>
        {listDom}
      </Spin>
    </ProCard>
  )
}

export default AppListCard
